// Auto-generated by scripts/generate-version.mjs. Do not edit.
export const appVersion = '1.3.29';
